var map = {
	"./blocks/custom/iconSlider/block.js": 616,
	"./blocks/sky/callToActionCharlie/block.js": 189,
	"./blocks/sky/headerAlfa/block.js": 3717,
	"./blocks/sky/headerBravo/block.js": 2241,
	"./blocks/sky/sliderAlfa/block.js": 3089,
	"./blocks/sky/sliderBravo/block.js": 7781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9363;